// Intro Text
const Header = () => {
  return (
    <header className='App-header'>
      <h1>Autocomplete Component</h1>
    </header>
  );
};

export default Header;
